var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader-box",class:{ 'local-position': _vm.local }},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"loader-text"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lds-ring"},[_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div')])
}]

export { render, staticRenderFns }